



































import { Component, Prop, Vue } from "vue-property-decorator";
import VcNavArrow from "@/components/form_components/VcNavArrow.vue";
import { RentangTanggal } from "@/types/orderGizi";

@Component({
  components: { VcNavArrow }
})
export default class TanggalGizi extends Vue {
  @Prop({ default: null }) readonly value!: string | RentangTanggal | null;
  @Prop({ type: String, default: "" }) readonly label!: string;
  @Prop({ type: String, default: "" }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly range!: boolean;
  @Prop({ type: Boolean, default: false }) readonly clearable!: boolean;
  @Prop({ default: null }) readonly maxDate!: Date | null;

  readonly modelConfig = { type: "string", mask: "YYYY-MM-DD" };

  get tampil(): string {
    if (!this.value) return "";

    if (typeof this.value === "string") {
      return this.format(this.value);
    }

    if (!this.value.start || !this.value.end) return "";

    return this.value.start === this.value.end
      ? this.format(this.value.start)
      : `${this.format(this.value.start)} s/d ${this.format(this.value.end)}`;
  }

  ubah(nilai: string | RentangTanggal | null) {
    this.$emit("input", nilai || null);
  }

  format(tanggal: string): string {
    if (!tanggal || tanggal.length < 10) return "";
    const [y, m, d] = tanggal.slice(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }
}
